"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.disableByWeekRange = exports.DateRangePicker = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var styles_1 = require("../../styles");
var DateField_1 = require("../DateField/DateField");
var FocusManagerContainer_1 = require("../FocusManagerContainer");
var ControlledDateRangeCalendar_1 = require("../Calendar/RangeCalendar/DateRangeCalendar/ControlledDateRangeCalendar");
var DateRangePickerInput_1 = require("./DateRangePickerInput");
function DateRangePicker(props) {
    var onChange = props.onChange, popperProps = props.popperProps, minDate = props.minDate, maxDate = props.maxDate, value = props.value, icon = props.icon, calendarProps = props.calendarProps, onFocus = props.onFocus, onBlur = props.onBlur, onlyWeeks = props.onlyWeeks, rest = __rest(props, ["onChange", "popperProps", "minDate", "maxDate", "value", "icon", "calendarProps", "onFocus", "onBlur", "onlyWeeks"]);
    var _a = react_1.useState(1), dateRangeInputFocus = _a[0], setDateRangeInputFocus = _a[1];
    var _b = react_1.useState(new Date()), visibleDate = _b[0], setVisibleDate = _b[1];
    var _c = react_1.useState(false), open = _c[0], setOpen = _c[1];
    var _d = styles_1.useStyles(exports.createStyles), classes = _d.classes, css = _d.css;
    var finalInputRef = react_1.useRef();
    var _e = react_1.useState(), anchorRef = _e[0], setAnchorRef = _e[1];
    var _f = react_1.useState(), popupRef = _f[0], setPopupRef = _f[1];
    react_1.useEffect(function () {
        var point = function () {
            if (dateRangeInputFocus === 1 && (value === null || value === void 0 ? void 0 : value.startDate)) {
                return value.startDate;
            }
            else if (dateRangeInputFocus === 2 && (value === null || value === void 0 ? void 0 : value.endDate)) {
                return value.endDate;
            }
            else if ((value === null || value === void 0 ? void 0 : value.startDate) && !(value === null || value === void 0 ? void 0 : value.endDate)) {
                return value.startDate;
            }
            else if (!(value === null || value === void 0 ? void 0 : value.startDate) && (value === null || value === void 0 ? void 0 : value.endDate)) {
                return value.endDate;
            }
            else {
                return new Date();
            }
        };
        setVisibleDate(point);
    }, [dateRangeInputFocus, value]);
    var _g = react_popper_1.usePopper(anchorRef, popupRef, __assign(__assign({}, popperProps), { placement: 'bottom' })), popperStyle = _g.styles.popper, placement = _g.attributes.placement;
    var handleInputFocus = function (inputOnFocus) { return setDateRangeInputFocus(inputOnFocus); };
    var handleOnDayClick = function () { return finalInputRef.current.focus(); };
    var handleFocusIn = function (event) {
        onFocus && onFocus(event);
        setOpen(true);
    };
    var handleFocusOut = function (event) {
        onBlur && onBlur(event);
        setOpen(false);
    };
    var handleDateRangeChanged = function (rangeDateFromBaseInput) {
        onChange(rangeDateFromBaseInput);
    };
    var handleCalendarDateRangeChanged = function (dateRange) {
        var startDate = dateRange.startDate, endDate = dateRange.endDate;
        startDate && endDate
            ? startDate <= endDate
                ? onChange({ startDate: startDate, endDate: endDate })
                : onChange({ startDate: endDate, endDate: startDate })
            : onChange({ startDate: startDate, endDate: endDate });
    };
    var handleOnVisibleDateChange = function (vDate) { return setVisibleDate(vDate); };
    return (react_1.default.createElement(FocusManagerContainer_1.FocusManagerContainer, { onFocusIn: handleFocusIn, onFocusOut: handleFocusOut },
        react_1.default.createElement(DateRangePickerInput_1.DateRangePickerInput, __assign({ value: value, onChange: handleDateRangeChanged, divRef: setAnchorRef, minDate: minDate, maxDate: maxDate, icon: icon, finalInputRef: finalInputRef, onInputOnFocus: handleInputFocus }, rest)),
        open && (react_1.default.createElement("div", { ref: setPopupRef, className: css(classes.root, popperStyle), "data-placement": placement, tabIndex: -1 },
            react_1.default.createElement(ControlledDateRangeCalendar_1.ControlledDateRangeCalendar, __assign({ value: value, onChange: handleCalendarDateRangeChanged, onDayClick: handleOnDayClick, inputOnFocus: dateRangeInputFocus, visibleDate: visibleDate, onVisibleDateChange: handleOnVisibleDateChange, minDate: minDate, maxDate: maxDate, modifiers: {
                    disabled: onlyWeeks ? exports.disableByWeekRange(minDate, maxDate) : DateField_1.disableByRange(minDate, maxDate),
                }, onlyWeeks: onlyWeeks }, calendarProps))))));
}
exports.DateRangePicker = DateRangePicker;
DateRangePicker.defaultProps = {
    onlyWeeks: false,
    icon: 'calendarOutline',
};
exports.disableByWeekRange = function (minDate, maxDate) {
    var realMinDate = new Date(minDate);
    realMinDate.setHours(0, 0, 0, 0);
    var realMaxDate = new Date(maxDate);
    realMaxDate.setHours(23, 59, 59, 999);
    return function (week) {
        return (minDate && week.start < realMinDate) || (maxDate && week.end > realMaxDate);
    };
};
exports.createStyles = function (theme) { return ({
    root: {
        zIndex: theme.zIndex.popper,
        background: theme.pallete.surface.main,
        boxShadow: theme.shadows.outer[40],
        borderRadius: theme.radius.popper,
        padding: '0.5rem .25rem .25rem .25rem',
        outline: 'none',
    },
}); };
//# sourceMappingURL=DateRangePicker.js.map